import { FC } from "react";
import { Button } from "@mui/material";
import { FormattedMessage } from "react-intl";
import { useFormContext } from "react-hook-form";
import { emptyAnalytics } from "../../../empty";

export interface IClearButtonProps {
  onReset?: () => void;
}

export const ClearButton: FC<IClearButtonProps> = props => {
  const { onReset = () => {} } = props;
  const form = useFormContext();

  const handleClear = () => {
    form.reset(emptyAnalytics);
    onReset();
  };

  return (
    <Button onClick={handleClear}>
      <FormattedMessage id="form.buttons.clear" />
    </Button>
  );
};
